const { saveState } = require("../utils/localStorage");

export default function changeLang(paths, lang) {
  saveState(lang, "vt_lang");
  window.location.href = paths[lang];
}
